
<div class="btn-group">
    <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ title }}</button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a href="#" class="dropdown-item">ボタン１</a>
        <a href="#" class="dropdown-item">ボタン２</a>
        <a href="#" class="dropdown-item">ボタン３</a>
    </div>
</div>
